module.exports = __webpack_public_path__ + "img/wealthmiddle.5f97e50f.png";